import styled from "styled-components";

export const Container = styled.div`
  @media screen and (max-width: 568px) {
    .heading {
      flex-direction: column;
      gap: 20px;
      h1 {
      font-size: 20px;
    }
    }
  }
  .approval {
    display: flex;
    justify-content: space-between;
    width: 856px;
    @media screen and (max-width: 1268px) {
      width: 100%;
    }
  }
  .link-buttons {
    display: flex;
    gap: 10px;
    .see-more,
    .add-campaign {
      padding: 10px 16px;
      height: 40px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      font-size: 14px;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      color: #344054;
    }
    .see-more:disabled,
    .add-campaign:disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }
    .add-campaign {
      color: #fff;
      border: 1px solid #3730a3;
      background-color: #3730a3;
    }
  }
  .heading {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    h1 {
      font-size: 30px;
      line-height: 52px;
      color: #171a2f;
    }
    p {
      font-size: 16px;
      line-height: 24px;
      color: #546881;
    }
  }

  h4 {
    font-size: 14px;
    color: #101828;
    line-height: 20px;
  }
  hr {
    margin-top: 20px;
    margin-bottom: 40px;
    border: none;
    border-bottom: 1px solid #D0D5DD;
  }
  .outside {
    width: 856px;
    @media screen and (max-width: 1268px) {
      width: 100%;
    }
  }
`;

export const Details = styled.div`
  @media screen and (max-width: 1268px) {
    width: 100%;
  }
  margin-top: 15px;
  width: 856px;
  padding: 25px 16px;
  border: 1px solid #d0d5dd;
  border-radius: 12px;

  .img {
    width: 100%;
    height: auto;
    border-radius: 12px;
  }

  .wrapper {
    display: flex;
    justify-content: space-between;
    hr {
      margin-top: 10px;
      margin-bottom: 10px;
      border: none;
      border-bottom: 1px solid #d0d5dd;
    }

    label {
      font-size: 12px;
      color: #344054;
      line-height: 18px;
    }

    p,
    a {
      font-size: 14px;
      color: #344054;
      line-height: 18px;
      text-decoration: none;
    }
    .url {
      display: flex;
      justify-content: end;
      width: 50%;
    }
    a:hover {
      color: #3730a3;
    }
  }
`;
